
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
  components: {
    XHeader
  },
  data () {
    return {
      pageTitle: '管理员驾驶舱',
      userName: false
    }
  },
  mounted () {
    if (this.$store.state.userInfo.accounts) {
      this.userName = this.$store.state.userInfo.accounts
    }
  },
  methods: {
    goLogin () {
      this.$router.push({ name: 'Login'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Chart.vue